import { render, staticRenderFns } from "./assignDepartment.vue?vue&type=template&id=39252234&"
import script from "./assignDepartment.vue?vue&type=script&lang=js&"
export * from "./assignDepartment.vue?vue&type=script&lang=js&"
import style0 from "./assignDepartment.vue?vue&type=style&index=0&id=39252234&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports